import { vm } from '@/main';

export const toastSuccess = (message: string) => vm.$snotify.success(message);

export const toastInfo = (message: string) => vm.$snotify.info(message);

export const toastError = (message: string) => vm.$snotify.error(message);

export const toastWarning = (message: string) => vm.$snotify.warning(message);
